import {
  Box,
  IconArrowRight,
  IconWallet,
  Spot,
  Stack,
  Text,
} from '@n26/nxd'
import { ProfileInitials } from '@/shared/components/ProfileInitials'

type Recipient = {
  name: string
  iban: string
}

type TransferSummaryCardProps = {
  accountName: string
  balanceLabel: string
  recipient: Recipient
}

const Party = ({
  avatar,
  title,
  subtitle,
}: {
  avatar: React.ReactNode
  title: string
  subtitle: string
}) => (
  <Stack direction='horizontal' space='8' align='center'>
    {avatar}
    <Stack direction='vertical' space='4'>
      <Text>{title}</Text>
      <Text variant='small' color='neutral-alternate'>
        {subtitle}
      </Text>
    </Stack>
  </Stack>
)

export const TransferSummaryCard = ({
  accountName,
  balanceLabel,
  recipient,
}: TransferSummaryCardProps) => (
  <Box
    backgroundColor='neutral'
    borderColor='neutral'
    borderWidth='1'
    borderRadius='8'
    padding='16'
  >
    <Stack direction='horizontal' space='16' align='center' justify='space-between'>
      <Party
        avatar={
          <Spot color='teal'>
            <IconWallet />
          </Spot>
        }
        title={accountName}
        subtitle={balanceLabel}
      />
      <IconArrowRight />
      <Party
        avatar={<ProfileInitials label={recipient.name} />}
        title={recipient.name}
        subtitle={recipient.iban}
      />
    </Stack>
  </Box>
)
